import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const FooterLogo = () => { // Changed component name to FooterLogo
  return (
    <Link to="/" className="flex items-center gap-2">
      <img
        src="/demenshjaltar.svg"
        alt="Demenshjältar"
        className="h-8 w-8"
      />
      <div className="flex flex-col">
        <span className="text-xl font-bold text-white font-poppins"> {/* Changed text color to white & Added font-poppins */}
          Demenshjältar
        </span>
        <span className="text-xs text-gray-300">Tillsammans i kampen mot demens</span> {/* Updated slogan and adjusted color for better contrast on dark background */}
      </div>
    </Link>
  );
};

export default FooterLogo; // Changed export name to FooterLogo
